// import React from 'react';
import { Uppy } from '@uppy/core';
import { Dashboard } from '@uppy/react';

import { client } from '../../apollo';
import { fileToBase64, ApolloGraphQLUploads } from '../../utils';

require('@uppy/core/dist/style.css');
require('@uppy/dashboard/dist/style.css');
require('@uppy/status-bar/dist/style.css');

type Props = {
  onComplete: (data: any, url: any, client: any) => any;
  setUploadError?: (message: string) => any;
  uploadError?: string;
  allowedFileTypes?: string;
  dragDrop?: boolean;
  autoProceed?: boolean;
  onFileAdded?: (data: any) => void;
  client: any;
  maxFileUpload?: number;
};

const Uploader = (props: Props) => {
  const { onComplete, onFileAdded, setUploadError, uploadError, maxFileUpload } = props;
  const uppy = new Uppy({
    allowMultipleUploads: true,
    restrictions: {
      maxFileSize: 10 * 1024 * 1024,
      maxNumberOfFiles: maxFileUpload || 5,
      minNumberOfFiles: 1,
      allowedFileTypes: ['image/*'],
    },
  });
  uppy.use(ApolloGraphQLUploads, {
    client,
    onComplete,
    setUploadError,
    uploadError,
  });

  uppy.on('file-added', async (file: any) => {
    const base64 = await fileToBase64(file.data);
    uppy.setFileState(file.id, {
      data: base64.split(',').pop(),
    });

    if (onFileAdded) {
      onFileAdded(file);
    }
  });

  uppy.on('complete', async (result: any) => {
    if (!(result.successful && result.successful.length > 0)) {
      await onComplete(false, '', client);
    }
  });

  return (
    // @ts-ignore
    <Dashboard
      id="upload-dashboard"
      // @ts-ignore
      inline={false}
      trigger="#uppy-open"
      metaFields={[{ id: 'name', name: 'Name', placeholder: 'file name' }]}
      uppy={uppy}
      proudlyDisplayPoweredByUppy={false}
      closeAfterFinish={false}
      disablePageScrollWhenModalOpen={false}
      animateOpenClose={true}
      showProgressDetails={true}
      showSelectedFiles={true}
      note={maxFileUpload && maxFileUpload > 1 ? 'Multiple image files allowed' : 'Only one image allowed'}
    />
  );
};

Uploader.defaultProps = {
  autoProceed: true,
};

export default Uploader;
